import React, { useState, useRef, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';

/**
 * Dropdown UI for toggling table column visibility.
 */
export function ColumnConfigDropdown({ allColumns, isVisible, toggleColumn }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const toggleable = allColumns.filter(col => !col.alwaysVisible);

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => setOpen(!open)}
      >
        Columns &#9662;
      </Button>
      {open && (
        <div style={{
          position: 'absolute',
          right: 0,
          top: '100%',
          zIndex: 1000,
          backgroundColor: 'white',
          border: '1px solid #dee2e6',
          borderRadius: '0.375rem',
          padding: '0.5rem 0.75rem',
          minWidth: '180px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          marginTop: '2px',
        }}>
          <div style={{ fontSize: '0.75rem', color: '#6c757d', marginBottom: '0.25rem', fontWeight: 600 }}>
            Show / Hide Columns
          </div>
          {toggleable.map(col => (
            <Form.Check
              key={col.key}
              type="checkbox"
              id={`col-toggle-${col.key}`}
              label={col.label}
              checked={isVisible(col.key)}
              onChange={() => toggleColumn(col.key)}
              style={{ fontSize: '0.875rem' }}
              className="py-1"
            />
          ))}
        </div>
      )}
    </div>
  );
}
